/**
 * Compatibilidade: delega para useCrmAccess (direito da rede + permissão do usuário).
 */
import { useCrmAccess } from './useCrmAccess';

export function useHasCrmAccess() {
  const { state } = useCrmAccess();
  return {
    hasCrmAccess: state === 'allowed',
    isLoading: state === 'loading',
  };
}
